<template>
  <div class="container clear">
  	<div class="left-body-area">
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>分娩胎数
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhfmtc"></div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjfmtc < data1.jhfmtc}]">{{data1.sjfmtc}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>配种头数
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhpzts">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjpzts < data1.jhpzts}]">{{data1.sjpzts}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>出栏育肥猪数
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhclhz"></div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjclhz < data1.jhclhz}]">{{data1.sjclhz}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>出栏保育猪数
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhclbyzz">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjclbyzz < data1.jhclbyzz}]">{{data1.sjclbyzz}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>断奶仔猪数
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhdls">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjdls < data1.jhdls}]">{{data1.sjdls}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  	</div>
  	<div class="center-body-area">
  		<div class="center-item-body">
  			<div class="center-item-title">
  				<img src="../assets/title.png"/>生产力
  			</div>
  			<div id="map1" class="bk-tran">
  				
  			</div>
  		</div>
  		<div class="center-child-body clear">
  			<div class="center-child-leftbody">
  				<div class="center-item-title">
	  				<img src="../assets/title.png"/>当前存栏量
	  			</div>
	  			<div class="map bk-tran" id="main2">
	  				
	  			</div>
  			</div>
  			<div class="center-child-rightbody">
  				<div class="center-item-title">
	  				<img src="../assets/title.png"/>2019年累计出栏
	  			</div>
	  			<div class="map bk-tran" id="main3">
	  				
	  			</div>
  			</div>
  		</div>
  	</div>
  	<div class="right-body-area">
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>配种受胎率(%)
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data2.jhpzstl"></div>
  				</div>
  				<div class="item-body-right"> 
  					<p>实际值</p>
  					<div :class="['right-text',{down: data2.sjpzstl < data2.jhpzstl}]">{{data2.sjpzstl}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>配种分娩率(%)
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data2.jhpzfml">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data2.sjpzfml < data2.jhpzfml}]">{{data2.sjpzfml}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>仔猪成活率(%)
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data2.jhrzchl">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data2.sjrzchl < data2.jhrzchl}]">{{data2.sjrzchl}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>保育猪成活率(%)
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data2.jhblchl">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data2.sjblchl < data2.jhblchl}]">{{data2.sjblchl}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-title">
  				<img src="../assets/sm-title.png"/>肥猪成活率(%)
  			</div>
  			<div class="left-item-body">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data2.jhyhchl">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data2.sjyhchl < data2.jhyhchl}]">{{data2.sjyhchl}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import moment from "moment";
import echarts from "../../static/js/echart_init.js";
import { mapMutations } from 'vuex';
import myVue from "../js/emit.js";
export default {
  data () {
    return {
      data1: {},
      data2: {},
      weatherinfo: {}
    }
  },
  components: {
		
	},
  filters: {
  	'moment': (val,format) => {
  		return val.format(format);
  	}
  },
  methods: {
  	//左侧
  	init(){
  		this.$http({
        url: ""
      }).then(res => { 
       	if(res.data.statusCode == 200){
       		this.data1 = res.data.productionAnalysis.value;
       	}
      }).catch(err => { 
//      return this.$msg.error('修改失败!', 'top')
      })
      // 右侧
      this.$http({
        url: ""
      }).then(res => { 
       	if(res.data.statusCode == 200){
       		this.data2 = res.data.productionAnalysis.value;
       	}
      }).catch(err => { 
//      return this.$msg.error('修改失败!', 'top')
      })
  	},
  	initData1(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				this._initMap1(res.data);
  			}
  		})
  	},
  	_initMap1(data){
			// 基于准备好的dom,初始化echarts实例
	    var myChart2 = echarts.init(document.getElementById('map1'),'dark');
	    var color = [[ 0.33, "#FF526D" ],//0-50%处的颜色
                  [ 0.66, "#FF835C" ],//51%-70%处的颜色
//                [ 0.9, "#FDA84C" ],//70%-90%处的颜色
                  [ 1,"#36DF84" ]];
	    // 指定图表的配置项和数据
	    var option2 = {		
					tooltip : {
						formatter: "{b} : {c}"
					},
					series: [
						{
			        name: '业务指标',
			        type: 'gauge',
			        center: ['18%', '50%'],    // 默认全局居中
				 			radius: '60%',
		          axisLine : {
                show : false,
	              lineStyle : { // 属性lineStyle控制线条样式
                  color,
                  width : 15 //表盘宽度
	              }
		          },
		          axisLabel: {
		          	show: false
		          },
		          pointer: {
	              width: 4,
	              length: '50%'
	            },
		          splitLine: {
		          	length: 14,
		          	show: false
		          },
		          axisTick: {
		          	show: false
		          },
			        title:{
						textStyle: {       
	                // 其余属性默认使用全局文本样式,详见TEXTSTYLE
	                fontWeight:'bolder',
	                fontSize: 24,
	                color:"#1261E2"
							  },
						    offsetCenter: [0, '100%']
							},	
					 		textStyle: {       // 其余属性默认使用全局文本样式,详见TEXTSTYLE
                color: '#fff',
                fontSize: 14,
                fontWeight: 'bolder'
	            },
			        min: 0,
			        max: 40,
			        startAngle: 210,
			        endAngle: -30,
			        detail: {
			        	formatter:'{value}',
			        	fontSize: 24,
					 			fontWeight:'bolder',
			        },
			        data: [{value: data.productivity[0].PSY, name: 'PSY'}]
		        },
		        {
	            name: 'NPD',
	            type: 'gauge',
	            center: ['40%', '50%'],    // 默认全局居中
	            radius: '45%',
	            min: 0,
	            startAngle: 210,
	            endAngle: -30,
	            splitNumber: 5,
	            axisLabel: {
		          	show: false
		          },
	            axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                    width: 10,
                    color,
                }
	            },
	            axisTick: {            // 坐标轴小标记
	              show: false
	            },
	            splitLine: {           // 分隔线
                length:6,         // 属性length控制线长
                show: false
	            },
	            pointer: {
	               width: 2,
	               length: '50%'
	            },
	            title: {
				 				fontWeight:'bolder',
                fontSize: 18,
                color:"#1261E2",
                offsetCenter: [0, '105%'],       // x, y,单位px
	            },
	            detail: {
	              // 其余属性默认使用全局文本样式,详见TEXTSTYLE
					 			formatter:'{value}天',
					 			fontSize: 18,
					 			fontWeight:'bolder',
	            },
				data: [{value: data.productivity[0].NPD, name: 'NPD'}]
		        },
		        {
	            name: 'LSY',
	            type: 'gauge',
	            axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                    width: 10,
                    color,
                }
	            },
	            axisLabel: {
		          	show: false
		          },
	            center: ['60%', '50%'],    // 默认全局居中
	            radius: '45%',
	            min: 0,
	            max: 3,
	            startAngle: 210,
	            endAngle: -30,
	            splitNumber: 1,
	            axisTick: {            // 坐标轴小标记
	              show: false
	            },
	            splitLine: {           // 分隔线
                show: false,
	            },
	            pointer: {
	              width: 2,
	              length: '50%'
	            },
	            title: {
					 			fontWeight:'bolder',
	              fontSize: 18,
	              color:"#1261E2",
	              offsetCenter: [0, '105%'],       // x, y,单位px
	            },
	            detail: {
	              // 其余属性默认使用全局文本样式,详见TEXTSTYLE
	              formatter:'{value}胎',
	              fontSize: 18,
					 			fontWeight:'bolder',
	            },
	            data:	[{value: data.productivity[0].LSY,name: 'LSY'}]
		       	},
		        {
	            name: '窝均断仔数',
	            type: 'gauge',
	            center: ['80%', '50%'],    // 默认全局居中
	            radius: '45%',
	            min: 0,
	            max: 20,
							splitNumber: 4,
	            startAngle: 210,
	            endAngle: -30,
	            axisLabel: {
		          	show: false
		          },
	            axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                    width: 10,
                    color,
                }
	            },
	            axisTick: {            // 坐标轴小标记
	              show: false
	            },
	            splitLine: {           // 分隔线
                show: false
	            },
	            pointer: {
	              width: 2,
	              length: '50%'
	            },
	            title: {
					 			fontWeight:'bolder',
                fontSize: 18,
                color:"#1261E2",
                offsetCenter: [0, '105%']      // x, y,单位px
	            },
	            detail: {
	             	// 其余属性默认使用全局文本样式,详见TEXTSTYLE
					 			formatter:'{value}头',
					 			fontSize: 18,
					 			fontWeight:'bolder',
	            },
	            data:[{value: data.productivity[0].litterSize, name: '窝均断奶数'}]
		        }
				 	]
				};
	    // 使用刚指定的配置项和数据显示图表。
	    myChart2.setOption(option2);
  	},
  	initData2(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				this._initMap2(res.data);
  			}
  		})
  	},
  	_initMap2(data){
  		this.date1 = data.date;
  		// 基于准备好的dom,初始化echarts实例
      var myChart = echarts.init(document.getElementById('main2'),'dark'),
      legend = [], 
  		seriesData = [];
      data.cake.forEach((item,index) => {
      	legend.push(item.farm);
      	seriesData.push({
      		value: item.pigNum,
      		name: item.farm
      	});
      })
		  //var chart = echarts.init(dom, 'dark');
      // 指定图表的配置项和数据
      var option = {
			    tooltip: {
		        trigger: 'item',
		        formatter: "{a} <br/>{b}: {c} ({d}%)"
			    },
			    series: [
		        {
	            name:'存栏量',
	            type:'pie',
	            radius: [20, 80],
	            roseType : 'radius',
	            avoidLabelOverlap: true,
	            label: {
                normal: {
                formatter: '{b}({c})',
                borderWidth: 1,
                borderRadius: 2,
                rich: {                       
                    b: {
                    fontSize: 12,
                    lineHeight: 14
                    }
                	}
                }
	            },
	            labelLine: {
                normal: {
                  show: true
                }
	            },
	            data: seriesData
		        }
			    ]
			}
      myChart.setOption(option);
   },
   initData3(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				this._initMap3(res.data);
  			}
  		})
  	},
   _initMap3(data){
	    var myChart = echarts.init(document.getElementById('main3'),'dark'),
	    legend = [], 
  		seriesData = [];
      data.getGroupSales.forEach((item,index) => {
      	legend.push(item.orgName);
      	seriesData.push(item.inFarm);
      })
	    // 指定图表的配置项和数据
	    var option = {
				    xAxis: {
			        data: legend,
			        axisLabel: {
		            margin: 15
			        },
			        axisTick: {
			          show: false
			        },
			        axisLine: {
			          show: false
			        },
			        splitLine: {
			        	show: false
			        },
			        z: 10
				    },
				    yAxis: {
			        axisLine: {
			          show: false
			        },
			        axisTick: {
			          show: false
			        },
			        splitLine: {
			        	show: false
			        },
			        axisLabel: {
		            show: false
			        }
				    },
				    series: {
	            type: 'bar',
	            barMaxWidth: 50,
	            label: {
	            	position: 'top',
	            	show: true
	            },
	            data: seriesData
		        }
					};
	    myChart.setOption(option);
  	},
 	},
 	mounted(){ 
 		this.init();
 		this.initData1();
 		this.initData2();
 		this.initData3(); 
 		myVue.on("changeOrg",(data) => {
			this.init();
	 		this.initData1();
	 		this.initData2();
	 		this.initData3();
		})
//		this.changeName("新湘农集团生产中心看板");
	}
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../css/index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/index.vue